import { isMock } from '../config'
import { reservaMock } from './mock'
import { reservaReal } from './real'
import type { ReservaService } from './types'

export const reservaService: ReservaService = isMock('reserva') ? reservaMock : reservaReal
export { adultContactEmail, holderTraveler } from './holder'
export type { BookingPolicy, CancelQuote, ChangeConfirmation, ChangeInput, ChangeOption, ChangeOptions, ChangeOptionType, ChangeQuote, ChangeResult, ChangeType, GuideItem, PendingChangePayment, Phase, ReservaService, Stay, TimeChoice, UnitChoice } from './types'
